import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=ec4557f6&scoped=true&"
import script from "./user-card.vue?vue&type=script&lang=js&"
export * from "./user-card.vue?vue&type=script&lang=js&"
import style0 from "./user-card.vue?vue&type=style&index=0&id=ec4557f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4557f6",
  null
  
)

export default component.exports